import { Fragment, useEffect, useState } from 'react';
import { orderStyles } from 'views/Orders/styles';
import { isGranted } from 'helpers/helpers';
import { useTranslation } from 'react-i18next';
import { get, post, remove } from 'helpers/apiHelpers';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import ModalButton from 'components/CustomButtons/Button';
import roles from 'helpers/roles';
import { Dialog, DialogContent } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import ReactTable from 'react-table';
import TableActions from 'components/DataTable/Actions';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import { compose } from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { combineStyles } from 'helpers/helpers';
import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import NotesEditModal from './notesEditModal';
import columnConfig from './columnConfig';

// client
const Notes = ({ classes, urlParam, notePermission, userID }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [notesModalStatus, setNotesModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [editModalData, setEditModalData] = useState({});
  const [notes, setNotes] = useState([]);
  const [noteContent, setNoteContent] = useState('');
  const [selectedNote, setSelectedNote] = useState(null);
  const [isConfirmModalOpened, setIsConfirmModalOpened] = useState(false);
  const user = useSelector(state => state.Users.user);

  const { t } = useTranslation();

  // eslint-disable-next-line require-await -- FIXME
  const getNotes = async () => {
    // eslint-disable-next-line promise/prefer-await-to-then, no-shadow -- FIXME
    get('/notes', { key: urlParam }).then(notes => {
      setNotes(notes['hydra:member']);
    });
  };

  useEffect(() => {
    getNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const addNote = e => {
    if (!noteContent) {
      toast.error(t('errors.contentRequired'));
      return;
    }

    setIsLoading(true);

    e.preventDefault();
    post('/notes', {
      content: noteContent,
      key: urlParam,
    })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        setIsLoading(false);
        setNoteContent('');
        // eslint-disable-next-line no-use-before-define -- FIXME
        closeModal();
        toast.success(t('notes.noteAdded'));
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        setIsLoading(false);
      });
  };

  const closeModal = () => {
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    getNotes().then(() => {
      setNotesModalStatus(false);
    });
  };

  const hasPermissionToModifyOwnNotes = id =>
    !!(notePermission && isGranted(notePermission) && userID === id);

  const canEditNote = id => {
    if (isGranted(roles.ROLE_EDIT_NOTE)) {
      return true;
    }
    return !id || hasPermissionToModifyOwnNotes(id);
  };

  const canRemoveNote = id => {
    if (isGranted(roles.ROLE_REMOVE_NOTE)) {
      return true;
    }
    return !id || hasPermissionToModifyOwnNotes(id);
  };

  const notesWithActions = () => {
    // eslint-disable-next-line no-shadow -- FIXME
    const notesWithActions = notes.map(note => ({
      ...note,
      actions: (
        <TableActions
          handleEdit={
            isGranted(roles.ROLE_EDIT_NOTE) &&
            canEditNote(note.moderator?.['@id'])
              ? () => {
                  setEditModalStatus(true);
                  setEditModalData(note);
                }
              : false
          }
          handleRemove={
            isGranted(roles.ROLE_REMOVE_NOTE) &&
            canRemoveNote(note.moderator?.['@id'])
              ? () => {
                  setIsConfirmModalOpened(true);
                  setSelectedNote(note);
                }
              : false
          }
        />
      ),
    }));

    return notesWithActions;
  };

  return (
    isGranted(roles.ROLE_SHOW_NOTE) && (
      <Fragment>
        <Fragment>
          {isGranted(roles.ROLE_CREATE_NOTE) && (
            <FormControlButtons
              classes={classes}
              cancelPath="/admin/clients"
              discardText={t('dataGrid.backToList')}
              handleSubmit={() => {
                setNotesModalStatus(true);
              }}
              submitText={`${t('notes.addNote', 'Dodaj notatkę')} +`}
            />
          )}

          {notesModalStatus && (
            <Dialog
              maxWidth="xs"
              fullWidth={true}
              open={notesModalStatus}
              onClose={() => closeModal()}
            >
              <DialogContent>
                <ModalButton
                  style={orderStyles.closeButton}
                  color="transparent"
                  justIcon={true}
                  round={true}
                  onClick={() => closeModal()}
                >
                  <Close />
                </ModalButton>
                <div style={{ ...orderStyles.box }}>
                  <b>{t('notes.newNote')}</b>
                  <FormTextInput
                    multiline={true}
                    rowsMax={10}
                    label={t('notes.noteContent')}
                    classes={classes}
                    name="phone"
                    value={noteContent}
                    handleChange={e => setNoteContent(e.target.value)}
                    inputSize={12}
                    maxLength={400}
                  />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ModalButton
                      color="primary"
                      disabled={isLoading}
                      onClick={e => addNote(e)}
                    >
                      {t('notes.addNote')}
                    </ModalButton>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          )}
        </Fragment>

        <ReactTable
          data={notesWithActions()}
          filterable={false}
          sortable={false}
          resizable={false}
          columns={columnConfig(t)}
          minRows={10}
          showPaginationTop={true}
          showPaginationBottom={false}
          defaultPageSize={10}
          className="-striped -highlight"
          previousText={t('dataGrid.prevPage')}
          nextText={t('dataGrid.nextPage')}
          loadingText={t('dataGrid.loading')}
          noDataText={t('dataGrid.notFound')}
          pageText={t('dataGrid.page')}
          ofText={t('dataGrid.pageOf')}
          rowsText={t('dataGrid.results')}
        />
        {editModalStatus && (
          <NotesEditModal
            classes={classes}
            client={user}
            setNotes={setNotes}
            // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
            setNotesModalStatus={() => {}}
            editModalStatus={editModalStatus}
            setEditModalStatus={setEditModalStatus}
            editModalData={editModalData}
            t={t}
            getNotesAndCloseModal={closeModal}
          />
        )}
        <Dialog fullWidth={true} open={isConfirmModalOpened}>
          <SweetAlert
            warning={true}
            style={{ display: 'block' }}
            title={t('common.shared.areYouSure')}
            onConfirm={() => {
              // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
              remove(selectedNote['@id']).then(() => {
                getNotes();
                setIsConfirmModalOpened(false);
              });
            }}
            onCancel={() => setIsConfirmModalOpened(false)}
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
            cancelBtnCssClass={`${classes.button} ${classes.danger}`}
            confirmBtnText={t('common.shared.yes')}
            cancelBtnText={t('common.shared.no')}
            showCancel={true}
          />
        </Dialog>
      </Fragment>
    )
  );
};

const combinedStyles = combineStyles(
  sweetAlertStyle,
  extendedFormsStyle,
  buttonsStyle
);

const mapStateToProps = state => ({
  userID: state.Auth.user.id,
});

const enhance = compose(
  connect(mapStateToProps, null),
  withStyles(combinedStyles)
);

export default enhance(Notes);
